<p-toast />

<div class="campaign-rules">
  <section class="campaign-card">
    <div class="campaign-card__header">
      <div>
        <h2>{{ campaignId ? 'Editar Campanha' : 'Nova Campanha' }}</h2>
        <p *ngIf="campaignId">Campanha #{{ campaignId }}</p>
      </div>
    </div>

    <small *ngIf="isFinishedCampaign" class="warning">
      <i class="pi pi-lock"></i> Esta campanha está finalizada e não pode ser editada.
    </small>

    <form [formGroup]="form" class="form-b4a">
      <span class="p-float-label full-w">
        <input
          pInputText
          id="name"
          formControlName="name"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('name') }"
        />
        <label for="name">Nome da campanha *</label>
      </span>
      <span class="p-float-label">
        <p-calendar
          inputId="startDate"
          formControlName="startDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('startDate') }"
        ></p-calendar>
        <label for="startDate">Início da Validade *</label>
      </span>
      <span class="p-float-label">
        <p-calendar
          inputId="endDate"
          formControlName="endDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('endDate') }"
        ></p-calendar>
        <label for="endDate">Fim da Validade *</label>
      </span>
      <span class="p-float-label">
        <p-dropdown
          inputId="status"
          formControlName="status"
          [options]="statusOptions"
          optionDisabled="disabled"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('status') }"
        ></p-dropdown>
        <label for="status">Status da campanha *</label>
      </span>
      <span class="p-float-label full-w">
        <textarea
          pInputTextarea
          id="description"
          rows="4"
          formControlName="description"
          placeholder="Notas sobre a estratégia desta campanha..."
        ></textarea>
        <label for="description">Descrição Interna</label>
      </span>
      <div class="file-upload full-w">
        <label>Capa da Campanha</label>
        <p-fileUpload
          #fileUpload
          mode="basic"
          chooseLabel="Selecionar Imagem"
          accept="image/*"
          [maxFileSize]="1000000"
          [disabled]="isFinishedCampaign"
          [auto]="true"
          [customUpload]="true"
          (uploadHandler)="onFileSelect($event)"
          chooseIcon="pi pi-upload"
        ></p-fileUpload>
        <div *ngIf="coverUrl" class="campaign-cover-preview">
          <img [src]="coverUrl" alt="Capa da campanha" />
        </div>
      </div>
    </form>

    <div class="campaign-card__header">
      <div>
        <h2>Configuração do Brinde</h2>
      </div>
    </div>

    <form [formGroup]="giftForm" class="form-b4a">
      <span class="p-float-label">
        <input
          pInputText
          id="ean"
          formControlName="ean"
          (keyup.enter)="addGift()"
        />
        <label for="ean">EAN do Brinde</label>
      </span>
      <span class="p-float-label">
        <p-inputNumber
          inputId="quantity"
          formControlName="quantity"
          [min]="1"
          [useGrouping]="false"
        ></p-inputNumber>
        <label for="quantity">Quantidade</label>
      </span>
      <div class="buttons">
        <p-button
          label="Adicionar Brinde"
          [disabled]="isFinishedCampaign || validatingEan"
          [loading]="validatingEan"
          (onClick)="addGift()"
        ></p-button>
      </div>
    </form>

    <div class="gift-list" *ngIf="gifts.length">
      <div class="gift-card" *ngFor="let gift of gifts; let i = index">
        <div class="gift-card__info">
          <div class="gift-card__label">Produto</div>
          <div class="gift-card__title">
            {{ gift.productVariantName || gift.productVariantId || gift.internalEan }}
          </div>
          <div class="gift-card__subtitle">EAN: {{ gift.internalEan || gift.ean }}</div>
        </div>
        <div class="gift-card__meta">
          <div>
            <div class="gift-card__label">Qtd</div>
            <div class="gift-card__value">{{ gift.quantity || 0 }}</div>
          </div>
        </div>
        <p-button
          icon="pi pi-trash"
          [text]="true"
          severity="danger"
          [disabled]="isFinishedCampaign"
          (onClick)="removeGift(i)"
        ></p-button>
      </div>
    </div>
    <p *ngIf="!gifts.length" class="empty">
      <i class="pi pi-gift"></i> Nenhum brinde adicionado.
    </p>

    <div class="campaign-card__header">
      <div>
        <h2>Regras de Elegibilidade</h2>
      </div>
    </div>

    <form [formGroup]="form" class="form-b4a">
      <span class="p-float-label">
        <p-dropdown
          inputId="ruleType"
          [options]="ruleTypeOptions"
          formControlName="ruleType"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('ruleType') }"
        ></p-dropdown>
        <label for="ruleType">Mecânica</label>
      </span>
      <span class="p-float-label">
        <p-multiSelect
          *ngIf="subscriptionTypesTree?.length"
          inputId="subscriptionTypes"
          [options]="subscriptionTypesTree"
          [formControl]="subscriptionTypesControl"
          placeholder="Sem restrições"
          [showToggleAll]="false"
          appendTo="body"
          scrollHeight="250px"
          display="chip"
          [group]="true"
        >
          <ng-template let-group pTemplate="group">
            <span>{{ group.label }}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <span>{{ item.label }}</span>
          </ng-template>
          <ng-template let-value pTemplate="selectedItems">
            <span *ngFor="let item of value">{{ subscriptionLabel(item) }}, </span>
            <span *ngIf="!value?.length">Sem restrições</span>
          </ng-template>
        </p-multiSelect>
        <label for="subscriptionTypes">Planos Válidos</label>
      </span>
    </form>

    <div class="buttons">
      <p-button
        icon="pi pi-check"
        label="Finalizar Configuração"
        type="button"
        [disabled]="isFinishedCampaign || form.invalid"
        (onClick)="saveRules()"
      ></p-button>
    </div>
  </section>
</div>
